import React, { Component } from "react";
import {
  Button,
  Row,
  Col,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import WidgetInstanceEditor from "../widgets/editors/WidgetInstanceEditor";

import LoadingOverlay from "./LoadingOverlay";
/**
 * Widgetinstancesmanager - Management page for widget instances.
 * DataTable list + WidgetInstanceEditor in Offcanvas for create/edit.
 */
export default class Widgetinstancesmanager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      widgetTypes: [],
      filteredData: null,
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      editInstanceId: null,
      currentPage: 1,
      itemsPerPage: 100,
      tableClms: [
        {
          name: "ID",
          selector: (row) => row.widget_instances_Id,
          sortable: true,
          width: "70px",
          cell: (row) => <span>{row.widget_instances_Id}</span>,
        },
        {
          name: "Instance Name",
          selector: (row) => row.instanceName,
          sortable: true,
          cell: (row) => <span>{row.instanceName}</span>,
        },
        {
          name: "Widget Type",
          selector: (row) => row.widget_types_Id,
          sortable: true,
          width: "120px",
          cell: (row) => <Badge bg="info">{row.widget_types_Id}</Badge>,
        },
        {
          name: "API Endpoint",
          selector: (row) => row.apiEndPoint,
          sortable: true,
          cell: (row) => (
            <span style={{ fontSize: "0.85rem", fontFamily: "monospace" }}>
              {row.apiEndPoint}
            </span>
          ),
        },
        {
          name: "Source Table",
          selector: (row) => row.sourceTable,
          sortable: true,
          width: "140px",
          cell: (row) => <span>{row.sourceTable}</span>,
        },
        {
          name: "Active",
          selector: (row) => row.isActive,
          sortable: true,
          width: "80px",
          cell: (row) => (
            <Badge bg={parseInt(row.isActive) === 1 ? "success" : "secondary"}>
              {parseInt(row.isActive) === 1 ? "Yes" : "No"}
            </Badge>
          ),
        },
        {
          name: "Actions",
          sortable: false,
          width: "120px",
          cell: (row) => (
            <div>
              <Button
                variant="primary"
                className="bi bi-pen"
                size="sm"
                style={{ marginRight: "3px" }}
                onClick={() => this.handleEdit(row)}
              />
              <Button
                variant="danger"
                className="bi bi-trash"
                size="sm"
                onClick={() => this.handleDelete(row)}
              />
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchData();
    this.fetchWidgetTypes();
  }

  fetchData = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Widget_instances/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list || [] });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        toast.error("Failed to load widget instances");
      });
  };

  fetchWidgetTypes = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Widget_types/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ widgetTypes: data.list || [] });
        }
      })
      .catch((error) => {
        console.error("Widget types fetch error:", error);
      });
  };

  handleOffcanvasShow = () => {
    this.setState({ show: true, editInstanceId: null });
  };

  handleOffcanvasClose = () => {
    this.setState({ show: false, editInstanceId: null });
  };

  handleEdit = (row) => {
    this.setState({ show: true, editInstanceId: row.widget_instances_Id });
  };

  handleDelete = (row) => {
    if (!window.confirm("Are you sure you want to delete this widget instance?")) return;

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widget_instances_Id", row.widget_instances_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Widget_instances/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        if (data.status === "success") this.fetchData();
      
        this.setState({ loading: false });})
      .catch(() => toast.error("Failed to delete"))
    .catch(() => { this.setState({ loading: false }); });
  };

  handleEditorSave = () => {
    this.handleOffcanvasClose();
    this.fetchData();
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    if (!searchValue) {
      this.setState({ filteredData: null });
      return;
    }
    const filteredData = this.state.data.filter((row) =>
      Object.values(row).join(" ").toLowerCase().includes(searchValue)
    );
    this.setState({ filteredData });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  render() {
    const displayData = this.state.filteredData || this.state.data;
    const paginatedData = displayData.slice(
      (this.state.currentPage - 1) * this.state.itemsPerPage,
      this.state.currentPage * this.state.itemsPerPage
    );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div id="datatable_wrapper" className="dataTables_wrapper form-inline dt-bootstrap no-footer">
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
                        <i className="bi bi-window me-2"></i>
                        Widget Instances Manager
                      </h3>
                    </div>
                    <Col className="d-flex justify-content-end" style={{ marginRight: "5px", marginTop: "20px" }}>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        style={{ width: "700px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            {this.state.editInstanceId ? "Edit Widget Instance" : "New Widget Instance"}
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <WidgetInstanceEditor
                            instanceId={this.state.editInstanceId}
                            widgetTypes={this.state.widgetTypes}
                            onSave={this.handleEditorSave}
                            onClose={this.handleOffcanvasClose}
                          />
                        </Offcanvas.Body>
                      </Offcanvas>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={displayData.length}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
